import { useEffect, useState } from "react";

function MainPopupSettings({ competitionProps }: { competitionProps: any }) {
    const [adminSettings, setAdminSettings] = useState([]);

    const onSetSettingsText = (e: any) => {
        let items = [...adminSettings];

        let value = e.target.value;
        let data = e.target.dataset.name;
        
        // @ts-ignore
        let item = {...items[0]};
        // @ts-ignore
        item[data] = value;

        // @ts-ignore
        items[0] = item;

        setAdminSettings(items);
    }

    const handleCloseEvent = () => {
        competitionProps.handleClose();
    }

    const handleSaveEvent = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(adminSettings)
        };
        fetch('/api/settings/update', requestOptions)
            .then(response => response.json())
            .then(data => alert("Successfully saved your settings."));
        
        competitionProps.handleClose();
    }

    useEffect(() => {
        setAdminSettings(competitionProps.settingsData);
    }, [competitionProps.settingsData]);

    return (
      <div className="pfgame-popup" style={{ display: (competitionProps.show) ? "flex" : "none"}}>
          {(adminSettings.length > 0) ? (adminSettings.map((setting: any) => (
            <div className="pfgame-popup__form-wrapper">
                <div className="pfgame-popup__form-wrapper--header">
                    Edit Generator Settings
                </div>

                <div className="pfgame-popup__form-wrapper--input-zone">
                    <div className="input-group">
                        <label>
                            Monthly Max Credits: 
                        </label>
                        <input name="competition_name" type="number" className="pfgame-main-input" value={adminSettings[0]["monthly_max_credit"]} onChange={onSetSettingsText} data-name="monthly_max_credit" />
                    </div>

                    <div className="input-group">
                        <label>
                            Competition Hourly Credit: 
                        </label>
                        <input name="competition_english_name" type="number" className="pfgame-main-input" value={adminSettings[0]["competition_hourly_credit"]} onChange={onSetSettingsText} data-name="competition_hourly_credit" />
                    </div>

                    <div className="input-group">
                        <label>
                            Minimum Competition Duration In Hours: 
                        </label>
                        <input name="competition_name" type="number" className="pfgame-main-input" value={adminSettings[0]["min_competition_duration_in_hours"]} onChange={onSetSettingsText} data-name="min_competition_duration_in_hours" />
                    </div>

                    <div className="input-group">
                        <label>
                            Maximum Competition Duration In Hours: 
                        </label>
                        <input name="competition_english_name" type="number" className="pfgame-main-input" value={adminSettings[0]["max_competition_duration_in_hours"]} onChange={onSetSettingsText} data-name="max_competition_duration_in_hours" />
                    </div>

                    <button className="pfgame-main-button btn-red" onClick={handleCloseEvent}>Cancel</button>
                    <button className="pfgame-main-button btn-dark" onClick={handleSaveEvent}>Save</button>
                </div>
            </div>
        ))) : (
            <p className="text-center">Loading settings...</p>
        )}
      </div>
    );
  }

export { MainPopupSettings };